import React from 'react';
import BreadcrumbAntd from '@common/BreadcrumbAntd';
import LessonPlannerStatusButton from './LessonPlannerStatusButton';
import { CalendarTodayRounded } from '@mui/icons-material';

// Demo mock — remove this block and wire up real schedule/lesson data when backend is ready
const MOCK = {
    scheduleName: 'Demo Schedule',
    unitName: 'Unit 1',
    lessonIndex: 1,
    lessonTotal: 6,
    classes: [
        { name: '9 Kangaroo', status: 'PLANNED' },
        { name: '9 Wombat', status: 'PLANNED' },
    ],
};

const LessonScheduleNavigator = () => {
    const { scheduleName, unitName, lessonIndex, lessonTotal, classes } = MOCK;

    const breadcrumbs = [
        { label: scheduleName, function: () => {} },
        { label: unitName, function: () => {} },
        { label: `Lesson ${lessonIndex} of ${lessonTotal}`, function: () => {} },
    ];

    return (
        <div className="ch-lesson-schedule-nav">
            <div className="ch-lesson-schedule-nav__top">
                <div className="ch-lesson-schedule-nav__crumb-row">
                    <CalendarTodayRounded className="ch-lesson-schedule-nav__cal-icon" />
                    <BreadcrumbAntd breadcrumbs={breadcrumbs} />
                </div>
                <div className="ch-lesson-schedule-nav__classes ch-lesson-planner-classes-list">
                    {classes.map(cls => (
                        <div key={cls.name} className="ch-lesson-planner-class-col">
                            <span className="ch-lesson-planner-class-col-name">{cls.name}</span>
                            <LessonPlannerStatusButton status={cls.status} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LessonScheduleNavigator;
